import styled from 'styled-components';

const Item = styled.div`
  border-bottom: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  padding-bottom: 16px;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export { Item };
